export default __webpack_public_path__ + "static/media/5-pdf.76ed8cec.png";